import { render, staticRenderFns } from "./AppOnBoarding.vue?vue&type=template&id=3ee5a982&"
import script from "./AppOnBoarding.vue?vue&type=script&lang=js&"
export * from "./AppOnBoarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports